import { render, staticRenderFns } from "./xy-pagelet-renderer.vue?vue&type=template&id=b3ff4f92"
import script from "./xy-pagelet-renderer.vue?vue&type=script&lang=js"
export * from "./xy-pagelet-renderer.vue?vue&type=script&lang=js"
import style0 from "./xy-pagelet-renderer.vue?vue&type=style&index=0&id=b3ff4f92&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports